module.exports = __webpack_public_path__ + "static/assets/707c254cfe9d82a931a0d96eba1e9614.png";